import {PAISESINDICATIVO} from "../Utilidades/indicativos";


export const obtenerIndicativoPais = (pais) => {

    if(!pais){
        return ''
    }

    let index = PAISESINDICATIVO.findIndex((it) => it.nameES === pais);
    if (index >= 0) {
        return PAISESINDICATIVO[index].phoneCode;
    }else{
        return ''
    }

}